import { moduleProviderFactory } from "core/providers";
import { PumpLanding } from "application/pumps/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.pumps",
                pattern: "/pumps",
                children: [
                    {
                        name: "master.app.main.pumps.landing",
                        pattern: "",
                        tabTitle: 'Pump Tracking',
                        component: PumpLanding,
                        authorization: 'pumpTrackingSection.read',
                        data: {
                            title: "PUMPS.LANDING.TITLE",
                        },
                    },
                ],
            },
        ],
        menu : [
            {
                title: 'MENU.PUMPS',
                order: 8,
				icon: "pump",
                subMenu: [
                    {
                        title: "MENU.PUMPS",
                        route: "master.app.main.pumps.landing",
                        icon: "pump",
                        order: 1,
                    }                    
                ]
            }
        ]
    });
})();
